console.log('Bit bucket work');
// Account toggle

 $(document).ready(function () {
  // console.log("The paragraph was clicked.")
$("header-drawer").click(function(){
 $(".menu-drawer-container").addClass("menu-opening");
  // $("body").addClass("overflow-hidden-tablet")
});

$(".header__icon--menu .icon-hamburger").click(function(){
$("body").addClass("overflow-hidden-tablet");
  $(".section-header").addClass("menu-open");
});
$(".header__icon--menu .icon-close").click(function(){
  $("body").removeClass("overflow-hidden-tablet");
    $(".section-header").removeClass("menu-open");
});
 });
$(document).ready(function(){
  var url1 = new URL(window.location.href);
  var searchParams = url1.searchParams;
  console.log(searchParams.get('UTM')+"searchparam");
  if ( searchParams.get('UTM') == "lazada" )
  {
    $("input.utm-parameter-tag").removeAttr("disabled");
  }
})
function toggleFunction(event) {
  console.log(event.currentTarget);
  event.currentTarget.classList.toggle("active");
  document.querySelector(".customer-dropdown").classList.toggle("active");
}

// var element = document.querySelector(".customer-dropdown");
// window.onclick = function (event) {
//   if (element.classList.contains("active")) {
//   console.log(event.target.parentElement)
//   if (!event.target.parentElement.matches('.header__icon--account')) {
//     var sharedowns = document.getElementsByClassName("customer-dropdown");
//     var i;
//     for (i = 0; i < sharedowns.length; i++) {
//       var openSharedown = sharedowns[i];
//       if (openSharedown.classList.contains('active')) {
//         openSharedown.classList.remove('active');
//         document.querySelector(".header__icon.header__icon--account").classList.remove('active');
//       }
//     }
//   }
// }
// }

var myDiv = document.querySelector(".customer-dropdown");
var accDiv = document.querySelector(".header__icon--account");

// console.log(myDiv);
if (myDiv != null) {

  document.addEventListener("click", function (event) {
    var isClickInside = myDiv.contains(event.target);
    var isClickaccDivInside = accDiv.contains(event.target);
    if (!isClickInside) {
      //console.log('!inside');
      accDiv.classList.remove("active");
      myDiv.classList.remove("active");
    } else {
    //  console.log('inside');
    }
    if (!isClickaccDivInside) {
    //  console.log('!inside');

    } else {
    //  console.log('inside');
      accDiv.classList.add("active");
      myDiv.classList.add("active");
    }

  });
}



// console.log(customElements);
//footer accordion
[...document.querySelectorAll('.footer-block__heading')].forEach(function (item) {
  item.addEventListener('click', function () {
    item.classList.toggle('footer-accordion');
    item.nextElementSibling.classList.toggle('footer-accordion-active');
    item.nextElementSibling.nextElementSibling.classList.toggle('footer-accordion-active');
  });
});

//  page mobile accordion
function openTab(evt, cityName) {
  document.getElementById(cityName).classList.toggle("active");
}


// bundle popup
function radioClick(data) {
  var selectedSize = data.value;
  if (data.checked) {
    document.getElementById(selectedSize).classList.add("active");
    //console.log(data.value);
  } else {
    document.getElementById(selectedSize).classList.remove("active");
    //console.log('unchecked');
  }
  document.querySelector(".custom-continue-btn-error").innerHTML = "";
}

//open bundle pop up 
function openBundle_popupTab(evt, id) {
  document.body.classList.add("open_prescription");
  [...document.querySelectorAll('.open_prescription #MainContent .shopify-section')].forEach(function (section, i) {
   // console.log(i);
    if (i != 0) {
      section.classList.add("not-active");
    } else {
      section.classList.add("active");
      document.querySelector(".option_error").style.display = "none";

    }

  });

  [...document.querySelectorAll('.eyes-selection-wrap input[type="checkbox"]')].forEach(function (item) {
    if (item.checked) {
      var selectedSize = item.value;
      document.getElementById(id).classList.add("active");
      document.getElementById(selectedSize).classList.add("active");
      document.querySelector(".custom-continue-btn-error").innerHTML = "";
    } else {
      console.log('please select atleast one option');
      document.querySelector('#rightbox').classList.remove("disabled");
      document.querySelector('#leftbox b').textContent = "Left eye (OS)";
      document.querySelector(".custom-continue-btn-error").innerHTML = "please select at least one option";
    }
  });
  if (document.querySelector('#leftbox').classList.contains('active') && document.querySelector('#rightbox').classList.contains('active')) {
    document.querySelector(".same-prescription label").style.display = "block";
  } else {
    document.querySelector(".same-prescription label").style.display = "none";
  }

  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
}

// bundle popup close 
function closeFunction(evt, id) {
  console.log(id);
 document.getElementById(id).classList.remove("active");
  document.body.classList.remove("open_prescription");
  [...document.querySelectorAll('#MainContent .shopify-section')].forEach(function (section, i) {
    section.classList.remove("not-active");
    section.classList.remove("active");
  });
  document.querySelector('.same-prescription input').checked = false;
  document.querySelector('#rightbox').classList.remove("disabled");
  document.querySelector(".custom-continue-btn-error").innerHTML = "";
}


// other option change when both checked enable
if(document.querySelector('#left_bc')){
    
  document.querySelector('#left_bc').addEventListener('change', function () {
    const left_bcValue = this.value;
    document.querySelector('.same-prescription input').checked ? document.querySelector('#rightbox #right_bc').value = left_bcValue : console.log('same prescription unchecked');
  });

}
if(document.querySelector('#left_dia')){
  
document.querySelector('#left_dia').addEventListener('change', function () {
  const left_dia_Value = this.value;
  document.querySelector('.same-prescription input').checked ? document.querySelector('#rightbox #right_dia').value = left_dia_Value : console.log('same prescription unchecked');
});
}
  if(document.querySelector('#left_color')){
    
document.querySelector('#left_color').addEventListener('change', function () {
  const left_color_Value = this.value;
  document.querySelector('.same-prescription input').checked ? document.querySelector('#rightbox #right_color').value = left_color_Value : console.log('same prescription unchecked');
});
  }
   if(document.querySelector('#left_axis')){
     
document.querySelector('#left_axis').addEventListener('change', function () {
  const left_axis_Value = this.value;
  document.querySelector('.same-prescription input').checked ? document.querySelector('#rightbox #right_axis').value = left_axis_Value : console.log('same prescription unchecked');
});
   } 
     if(document.querySelector('#left_cyl')){
       
document.querySelector('#left_cyl').addEventListener('change', function () {
  const left_cyl_Value = this.value;
  document.querySelector('.same-prescription input').checked ? document.querySelector('#rightbox #right_cyl').value = left_cyl_Value : console.log('same prescription unchecked');
});
     }

if(document.querySelector('#left_add')){
  
document.querySelector('#left_add').addEventListener('change', function () {
  const left_add_Value = this.value;
  document.querySelector('.same-prescription input').checked ? document.querySelector('#rightbox #right_add').value = left_add_Value : console.log('same prescription unchecked');
});
}

// other option change when both checked enable end


// remove 's' from text --- product page 
[...document.querySelectorAll('.left-right-popup variant-selects .form__label')].forEach(function (form__label, i) {
  let word = form__label.textContent.trim();
  if (word.slice(-1) === "s") {
    word = word.slice(0, -1);
    form__label.textContent = word;
  }
});





// match both eyes 
function matchBothSide(data) {
  let leftid = document.querySelector('.left_side_input').value;
  let left_var_name = document.querySelector('.left_side_input').getAttribute('var_name');
  // let leftBC = document.querySelector('#left_bc').value;
  // let leftDia = document.querySelector('#left_dia').value;
  // let leftAxis = document.querySelector('#left_axis').value;
  // if (data.checked) {
  //   [...document.querySelectorAll('#leftbox select')].forEach(function (item, i) {
  //     console.log(i + ' = ' + item.value);
  //     document.querySelector('.right_option_' + i).value = item.value;
  //   });
  //   document.querySelector('.right_side_input').value = leftid;
  //   document.querySelector('#right_bc').value = leftBC;
  //   document.querySelector('#right_dia').value = leftDia;
  //   document.querySelector('#right_axis').value = leftAxis;
  // }
  let count = 0;
  if (data.checked) {
    document.querySelector('.right_side_input').value = leftid;
    document.querySelector('.right_side_input').setAttribute("var_name", left_var_name);
    [...document.querySelectorAll('.leftbox.active .product-form__input select')].forEach(function (el, i) {
      document.querySelectorAll('.rightbox.active .product-form__input select')[i].value = el.value;
    });

    [...document.querySelectorAll('.leftbox.active .field input')].forEach(function (el, i) {
      document.querySelectorAll('.rightbox.active .field input')[i].value = el.value;
    });

    console.log('checked both side');
    document.querySelector('#rightbox').classList.add("disabled");
    document.querySelector('#leftbox b').textContent = "Both Eyes";

  }else{
    console.log('checked both side else');
    document.querySelector('#rightbox').classList.remove("disabled");
    document.querySelector('#leftbox b').textContent = "Left eye (OS)";
  }




}








